module.exports = __webpack_public_path__ + "img/process.14622bb5.svg";